import { render, staticRenderFns } from "./ChangeEmail.vue?vue&type=template&id=5cfc7850"
import script from "./ChangeEmail.vue?vue&type=script&lang=js"
export * from "./ChangeEmail.vue?vue&type=script&lang=js"
import style0 from "./ChangeEmail.vue?vue&type=style&index=0&id=5cfc7850&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports